import { render, staticRenderFns } from "./NuevoRecordatorio.vue?vue&type=template&id=78045ab0&scoped=true"
import script from "./NuevoRecordatorio.vue?vue&type=script&lang=js"
export * from "./NuevoRecordatorio.vue?vue&type=script&lang=js"
import style0 from "./NuevoRecordatorio.vue?vue&type=style&index=0&id=78045ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78045ab0",
  null
  
)

export default component.exports